import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import LinkComp from 'components/atoms/LinkComp';
import ProductLimitMessage from 'components/mocules/ProductLimitMessage';
import { COLOR_STORE } from 'constants/Icons';
import { SVGPrice } from 'constants/SVG';
import { forwardRef } from 'react';
import { getSellerData } from 'services/SellerService';
import { DOMAIN_WEB_HOST } from 'sysconfig';
import { formatCurrency } from 'utils/FormatNumber';
import { ImageFallbackStatic } from 'utils/ImageFallback';
import QuantityControlTable from '../QuantityControlTable';
import styles from './styles.module.css';

function DiscountInfo({ displayPriceFormated, priceSave }) {
  return (
    <div className={styles.priceInfo}>
      {priceSave > 0 ? <Typography className={styles.save}>Tiết kiệm {formatCurrency(priceSave)}</Typography> : null}
      <Typography className={styles.price}> {<SVGPrice displayPriceFormated={displayPriceFormated} /> || 0}</Typography>
    </div>
  );
}

function RowHeader() {
  return (
    <Grid className={styles.gridContainer} container spacing={2}>
      <Grid className={clsx(styles.column)} item lg={5} sm={4}>
        <Typography className={styles.header}>Nhà bán hàng</Typography>
      </Grid>
      <Grid className={clsx(styles.column, styles.right)} item lg={3} sm={3}>
        <Typography className={styles.headerRight}>Giá bán</Typography>
      </Grid>
      <Grid className={clsx(styles.column)} item lg={4} sm={5} />
    </Grid>
  );
}

function RowBody({ product, priceCompare }) {
  const { tags = [], displayPriceFormated, displayPrice, sku, slug } = product;
  const { sellerName, individualNonVatSellerName = '' } = getSellerData({ seller: product.sellerInfo, tags });

  return (
    <Grid className={styles.gridContainer} container spacing={2} key={`${sku}`}>
      <Grid className={clsx(styles.column)} item lg={5} sm={4}>
        <LinkComp href={`${DOMAIN_WEB_HOST}/product/${slug || ''}`}>
          {individualNonVatSellerName || sellerName || (product?.vendorInfo && Object.keys(product.vendorInfo).length > 0) ? (
            <Typography className={styles.row}>{product?.vendorInfo?.name || individualNonVatSellerName || sellerName || ''}</Typography>
          ) : (
            <ImageFallbackStatic width="16" height="16" src={COLOR_STORE} alt="thuocsi store" className={styles.image_logo} />
          )}
        </LinkComp>
      </Grid>
      <Grid className={clsx(styles.column, styles.right)} item lg={3} sm={3}>
        <DiscountInfo priceSave={priceCompare - displayPrice} displayPriceFormated={displayPriceFormated} />
      </Grid>
      <Grid className={clsx(styles.column)} item lg={4} sm={5}>
        <div className={styles.wrapQuantity}>
          <ProductLimitMessage consumedMaxQuantity={product.consumedMaxQuantity} unit={product.unit} page="product" />
          <QuantityControlTable product={product} />
        </div>
      </Grid>
    </Grid>
  );
}

const AnotherSeller = forwardRef(function AnotherSeller(
  { products, title = '', toggleOpenModal, isModal, sellerTypeNoViewMore, productCompare },
  ref,
) {
  const { displayPrice } = productCompare;
  const updatedProducts = products;
  const checkConditionRender = () => {
    const listProduct = [...updatedProducts];
    if (isModal) return listProduct;
    if (listProduct.length > 2) return listProduct.slice(0, 3);
    return listProduct;
  };

  return (
    <div className={styles.container} ref={ref}>
      <Typography className={styles.title}>{title}</Typography>
      <div className={styles.table}>
        <RowHeader />
        {checkConditionRender().map((product) => (
          <RowBody product={product} sellerTypeNoViewMore={sellerTypeNoViewMore} key={`${product?.sku}`} priceCompare={displayPrice} />
        ))}
      </div>

      {toggleOpenModal && updatedProducts.length > 3 ? (
        <Typography className={styles.showAll} onClick={() => toggleOpenModal()}>
          Xem tất cả
        </Typography>
      ) : null}
    </div>
  );
});

export default AnotherSeller;
